export default __webpack_public_path__ + "static/media/post_back.38aab2d2.pdf";